import type { FormSpec } from "./formSpec"

export type FrameUiConfig = {
    frameOn: boolean
    frameClass: string
    headerAlign: "text-left" | "text-center"
    headerTitle?: string
    headerSubtitle?: string
    submitLabel: string
    submitLoadingLabel: string
    submitBtnClass: string
    showDividerBeforeSubmit: boolean
}

export function getFrameUiConfig(spec: FormSpec): FrameUiConfig {
    const ui = spec.ui || {}
    const submit = spec.submit
    const header = ui.header || {}

    const frameOn = ui.frame !== false
    const frameClass =
        ui.frameClassName ||
        "w-full rounded-2xl bg-background/70 backdrop-blur-xl shadow-[0_25px_60px_-10px_rgba(0,0,0,0.55)] p-8"

    const headerAlign: "text-left" | "text-center" = header.align === "center" ? "text-center" : "text-left"

    const submitLabel = submit.label || "Absenden"
    const submitLoadingLabel = submit.loadingLabel || "Lädt…"

    const submitBtnClass =
        ui.submitButtonClassName ||
        "w-full h-10 rounded-md text-sm font-medium bg-primary text-primary-foreground " +
        "disabled:bg-input disabled:text-foreground disabled:border disabled:border-input " +
        "disabled:opacity-70 disabled:cursor-not-allowed"

    const showDividerBeforeSubmit = ui.showDividerBeforeSubmit === true

    return {
        frameOn,
        frameClass,
        headerAlign,
        headerTitle: header.title,
        headerSubtitle: header.subtitle,
        submitLabel,
        submitLoadingLabel,
        submitBtnClass,
        showDividerBeforeSubmit,
    }
}